import {queryOptions} from '@github-ui/react-query'

import type {SavedViewsBoardAdapter} from '../types'
import type {IssuesBoardMetadata} from './board-metadata'
import type {BoardAxisLabels, BoardPayloadItem} from './board-payload'
import type {BoardCardActions} from './card-actions-payload'
import type {BoardDeferredFields} from './deferred-payload'

export const CARD_ACTIONS_QUERY_PREFIX = 'saved-views-board-card-actions'
/** Whether a viewer may act on an item changes with repository settings, not with the board. */
const CARD_ACTIONS_STALE_TIME_MS = 5 * 60_000

/** Loads the card menu actions the initial board payload leaves out, cached by view and item ID. */
export interface BoardCardActionsSource {
  /** Names the view independently of the board response, so refreshed boards reuse each item's actions. */
  scope: ReadonlyArray<string | number>
  /** Resolves `undefined` for an item the viewer cannot read. */
  load: (globalId: string) => Promise<BoardCardActions | undefined>
}

export type IssuesSavedViewBoardAdapter = SavedViewsBoardAdapter<
  BoardPayloadItem,
  IssuesBoardMetadata,
  BoardAxisLabels,
  BoardDeferredFields
> & {
  /** Answers, per card, the menu actions the initial payload leaves out. */
  cardActionsSource?: BoardCardActionsSource
}

export function boardCardActionsQueryOptions(globalId: string, source: BoardCardActionsSource) {
  return queryOptions({
    queryKey: [CARD_ACTIONS_QUERY_PREFIX, ...source.scope, globalId],
    queryFn: async (): Promise<BoardCardActions> => (await source.load(globalId)) ?? {},
    staleTime: CARD_ACTIONS_STALE_TIME_MS,
  })
}
